"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferPlanMode = void 0;
exports.TransferPlanMode = {
    BlindTransfer: "blind-transfer",
    BlindTransferAddSummaryToSipHeader: "blind-transfer-add-summary-to-sip-header",
    WarmTransferSayMessage: "warm-transfer-say-message",
    WarmTransferSaySummary: "warm-transfer-say-summary",
    WarmTransferWaitForOperatorToSpeakFirstAndThenSayMessage: "warm-transfer-wait-for-operator-to-speak-first-and-then-say-message",
    WarmTransferWaitForOperatorToSpeakFirstAndThenSaySummary: "warm-transfer-wait-for-operator-to-speak-first-and-then-say-summary",
};
